module.exports = __webpack_public_path__ + "static/media/JT.59591bb0.png";